// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"9":"e25dd4be","748":"69019f5a","882":"9e08d726","914":"4792137c","959":"69019f5a"}[chunkId] + ".chunk.css";
};